var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.025 12.975C14.325 13.275 14.325 13.725 14.025 14.025C13.875 14.175 13.725 14.25 13.5 14.25C13.275 14.25 13.125 14.175 12.975 14.025L9 10.05L5.025 14.025C4.875 14.175 4.725 14.25 4.5 14.25C4.275 14.25 4.125 14.175 3.975 14.025C3.675 13.725 3.675 13.275 3.975 12.975L7.95 9L3.975 5.025C3.675 4.725 3.675 4.275 3.975 3.975C4.275 3.675 4.725 3.675 5.025 3.975L9 7.95L12.975 3.975C13.275 3.675 13.725 3.675 14.025 3.975C14.325 4.275 14.325 4.725 14.025 5.025L10.05 9L14.025 12.975Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4584_25271",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.025 12.975C14.325 13.275 14.325 13.725 14.025 14.025C13.875 14.175 13.725 14.25 13.5 14.25C13.275 14.25 13.125 14.175 12.975 14.025L9 10.05L5.025 14.025C4.875 14.175 4.725 14.25 4.5 14.25C4.275 14.25 4.125 14.175 3.975 14.025C3.675 13.725 3.675 13.275 3.975 12.975L7.95 9L3.975 5.025C3.675 4.725 3.675 4.275 3.975 3.975C4.275 3.675 4.725 3.675 5.025 3.975L9 7.95L12.975 3.975C13.275 3.675 13.725 3.675 14.025 3.975C14.325 4.275 14.325 4.725 14.025 5.025L10.05 9L14.025 12.975Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4584_25271)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/ModalCloseIcon.f9a47c5432919ec3c010a1c87c79b328.svg";
export { ForwardRef as ReactComponent };